(function () {
'use strict';

var C = window.HavjoyCore;
var API_BASE = 'https://api.havjoy.com';

var SIZE_MAP   = { '9x12': '9x12', '12x16': '12x16', '16x20': '16x20' };
var SIZE_LABEL = { '9x12': 'Small', '12x16': '⭐ Most popular', '16x20': 'Large' };

// ===== DOM =====
var elRoot      = document.getElementById('hj-sd-root');
var elLoading   = document.getElementById('hj-sd-loading');
var elImageWrap = document.getElementById('hj-sd-image-wrap');
var elImg       = document.getElementById('hj-sd-img');
var elInfo      = document.getElementById('hj-sd-info');
var elName      = document.getElementById('hj-sd-product-name');
var elDate      = document.getElementById('hj-sd-date');
var elVariants  = document.getElementById('hj-sd-variants');
var elError     = document.getElementById('hj-sd-error');

if (!elRoot) return;

// ===== STATE =====
var sessionData  = null;
var productData  = null;
var selectedType = 'canvas';
var selectedSize = '9x12';

// ===== HELPERS =====
function formatDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  } catch(e) { return ''; }
}

function formatMoney(cents) {
  return C ? C.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
}

function findVariant(pattern) {
  if (!productData) return null;
  var p = pattern.toLowerCase();
  for (var i = 0; i < productData.variants.length; i++) {
    if (productData.variants[i].title.toLowerCase().includes(p)) return productData.variants[i];
  }
  return null;
}

function getCanvasVariant() {
  if (!C) return null;
  var sizeLabel = { '9x12': '9in x 12in', '12x16': '12in x 16in', '16x20': '16in x 20in' }[selectedSize] || '9in x 12in';
  var titlePart = selectedType === 'framed'
    ? 'Poster + Frame (' + sizeLabel + ')'
    : 'Wooden Canvas (' + sizeLabel + ')';
  return findVariant(titlePart);
}

function getDigitalVariant() {
  return C ? findVariant(C.VARIANT_DIGITAL) : findVariant('High Quality Digital File');
}

function cartProperties() {
  return { '_your_design': sessionData.result_url, '_session_id': sessionData.session_id };
}

function showToast(msg, type) {
  if (C) { C.showToast(msg, type); return; }
  var el = document.createElement('div');
  el.style.cssText = 'background:#333;color:#fff;padding:1rem 1.4rem;border-radius:0.6rem;font-size:1.4rem;pointer-events:auto';
  el.textContent = msg;
  document.getElementById('toast-container').appendChild(el);
  setTimeout(function() { el.remove(); }, 3500);
}

async function addToCart(variantId, label) {
  var btn = document.querySelector('[data-atc="' + label + '"]');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
  try {
    var r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: cartProperties() }] })
    });
    if (!r.ok) { var e = await r.json().catch(function(){return{};}); throw new Error(e.description || 'HTTP ' + r.status); }
    if (typeof CartDrawerController !== 'undefined') {
      CartDrawerController.open();
      CartDrawerController.update().catch(console.error);
    } else { window.location.href = '/cart'; }
  } catch(err) {
    showToast('Failed to add to cart. Please try again.', 'error');
    console.error(err);
  }
  if (btn) { btn.disabled = false; }
}

// ===== RENDER VARIANTS =====
function renderVariants() {
  var digitalVariant = getDigitalVariant();
  var canvasVariant  = getCanvasVariant();

  elVariants.innerHTML =
    // ---- Art Print card ----
    '<div class="hj-sd-vcard">' +
      '<div class="hj-sd-vcard__header">ART PRINT</div>' +
      '<div class="hj-sd-vcard__body">' +
        '<div class="hj-sd-print-type" id="hj-sd-pt">' +
          '<button class="hj-sd-pt-btn' + (selectedType === 'canvas' ? ' active' : '') + '" data-pt="canvas">' +
            '<img src="https://havjoy.com/cdn/shop/files/canvas1_1b90379f-528b-4f5a-a70a-b0d39d7091fc_120x.jpg" alt="Canvas">Canvas' +
          '</button>' +
          '<button class="hj-sd-pt-btn' + (selectedType === 'framed' ? ' active' : '') + '" data-pt="framed">' +
            '<img src="https://havjoy.com/cdn/shop/files/frame1_120x.jpg" alt="Framed">Framed' +
          '</button>' +
        '</div>' +
        '<p class="hj-sd-size-label">Size</p>' +
        '<div class="hj-sd-sizes" id="hj-sd-sizes">' +
          Object.keys(SIZE_MAP).map(function(k) {
            return '<button class="hj-sd-sz-btn' + (selectedSize === k ? ' active' : '') + '" data-sz="' + k + '">' +
              k + '<small>' + SIZE_LABEL[k] + '</small></button>';
          }).join('') +
        '</div>' +
        '<button class="hj-sd-atc-btn" data-atc="canvas">' +
          'Add to Cart' + (canvasVariant ? ' \u2014 ' + formatMoney(canvasVariant.price) : '') +
        '</button>' +
      '</div>' +
    '</div>' +

    // ---- Digital File card ----
    '<div class="hj-sd-vcard">' +
      '<div class="hj-sd-vcard__header">DIGITAL FILE</div>' +
      '<div class="hj-sd-vcard__body">' +
        '<div class="hj-sd-digital-row">' +
          '<img class="hj-sd-digital-img" src="' + (productData && productData.featured_image ? productData.featured_image : '') + '" alt="' + (productData ? productData.title : '') + '">' +
          '<div class="hj-sd-digital-feats">' +
            '<span class="hj-sd-digital-feat">Instant download</span>' +
            '<span class="hj-sd-digital-feat">High Resolution</span>' +
            '<span class="hj-sd-digital-feat">Print &amp; Share unlimited</span>' +
          '</div>' +
          (digitalVariant ? '<span class="hj-sd-digital-price">' + formatMoney(digitalVariant.price) + '</span>' : '') +
        '</div>' +
        '<button class="hj-sd-atc-btn" data-atc="digital">Download Now</button>' +
      '</div>' +
    '</div>';

  // Event: print type
  elVariants.querySelectorAll('[data-pt]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      selectedType = btn.dataset.pt;
      renderVariants();
    });
  });

  // Event: size
  elVariants.querySelectorAll('[data-sz]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      selectedSize = btn.dataset.sz;
      renderVariants();
    });
  });

  // Event: ATC canvas
  var canvasBtn = elVariants.querySelector('[data-atc="canvas"]');
  if (canvasBtn) {
    canvasBtn.addEventListener('click', function() {
      var v = getCanvasVariant();
      if (!v) { showToast('Variant not available', 'warning'); return; }
      addToCart(v.id, 'canvas');
    });
  }

  // Event: ATC digital
  var digitalBtn = elVariants.querySelector('[data-atc="digital"]');
  if (digitalBtn) {
    digitalBtn.addEventListener('click', function() {
      var v = getDigitalVariant();
      if (!v) { showToast('Digital variant not available', 'warning'); return; }
      addToCart(v.id, 'digital');
    });
  }
}

// ===== SHOW PAGE =====
function showPage() {
  elLoading.style.display = 'none';
  elImg.src = sessionData.result_url;
  elImageWrap.style.display = 'block';

  elName.textContent = (sessionData.product_handle || '').replace(/-/g, ' ');
  elDate.textContent = formatDate(sessionData.created_at);

  renderVariants();
  elInfo.style.display = 'flex';
}

// ===== INIT =====
function init() {
  var sid = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : null;
  console.log('[HavjoySession] sid:', sid);

  if (!sid) {
    console.warn('[HavjoySession] No sid in URL');
    elLoading.style.display = 'none';
    elError.style.display = 'block';
    return;
  }

  var apiUrl = API_BASE + '/session_info?sessionId=' + encodeURIComponent(sid);
  console.log('[HavjoySession] Fetching:', apiUrl);

  fetch(apiUrl)
    .then(function(r) {
      console.log('[HavjoySession] API status:', r.status);
      if (!r.ok) throw new Error('API returned HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      console.log('[HavjoySession] API response:', data);
      // Handle both { session_id, ... } and { sessions: [...] }
      sessionData = data.session_id ? data : (data.sessions && data.sessions[0]);
      if (!sessionData || !sessionData.result_url) throw new Error('No result_url in session');

      // Fetch product data — non-fatal
      return fetch('/products/' + sessionData.product_handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          productData = {
            title: p.title,
            featured_image: p.featured_image,
            variants: p.variants.map(function(v) {
              return { id: String(v.id), title: v.title, price: v.price, compare_at_price: v.compare_at_price };
            })
          };
        })
        .catch(function(e) { console.warn('[HavjoySession] Product fetch failed (non-fatal):', e); });
    })
    .then(function() {
      showPage();
    })
    .catch(function(e) {
      console.error('[HavjoySession] Fatal error:', e);
      elLoading.style.display = 'none';
      elError.style.display = 'block';
    });
}

// Wait for HavjoyCore if loaded via defer
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();
